import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const featuredCard = document.querySelectorAll(
    '.paragraph--type--featured-card'
  );

  if (featuredCard && featuredCard.length > 0) {
    featuredCard.forEach((element) => {
      const triggerElement = element;
      const animateElement = element.querySelector('img');
      const moveInFromLeft =
        triggerElement.classList.contains('alignment--left');

      gsap.fromTo(
        animateElement,
        {
          x: moveInFromLeft ? '-100%' : '100%',
        },
        {
          x: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom+=10%',
            end: '+=50%',
          },
        }
      );
    });
  }
});
